/* Sauber – Complementos en página de producto y carrito lateral */
(function () {
  'use strict';

  var CFG = window.SauberComp || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var recCache = {};

  function toSet(list) {
    var s = {};
    (list || []).forEach(function (id) { if (id) s[String(id)] = true; });
    return s;
  }
  var KIT = toSet(CFG.kitIds);          // productos con descuento kit
  var MACHINES = toSet(CFG.machineIds); // máquinas que activan el descuento
  var KIT_ON = !!CFG.kitOn;
  var KIT_PCT = Number(CFG.kitPct) || 15;
  var FREE_SHIP = Number(CFG.freeShipCents) || 0;

  /* ---------- utilidades ---------- */
  function formatMoney(cents) {
    var fmt = CFG.moneyFormat || '${{amount_no_decimals}}';
    var value = cents / 100;
    function withDelims(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return withDelims(value, 2, ',', '.');
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        default: return withDelims(value, 0, ',', '.');
      }
    });
  }

  function img(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fetchRecs(productId, limit) {
    var key = productId + ':' + (limit || 10);
    if (!recCache[key]) {
      recCache[key] = fetch(ROOT + 'recommendations/products.json?product_id=' + productId + '&intent=complementary&limit=' + (limit || 10))
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return (j.products || []).filter(function (p) { return p.available; }); })
        .catch(function () { return []; });
    }
    return recCache[key];
  }

  function firstAvailableVariant(p) {
    for (var i = 0; i < p.variants.length; i++) if (p.variants[i].available) return p.variants[i];
    return p.variants[0];
  }

  function prices(p) {
    var v = firstAvailableVariant(p);
    return { price: v ? v.price : p.price, compare: v ? v.compare_at_price : p.compare_at_price };
  }

  function isKit(p, kitContext) {
    return KIT_ON && kitContext && KIT[String(p.id)];
  }

  function kitPrice(cents) {
    return Math.round(cents * (100 - KIT_PCT) / 100 / 100) * 100;
  }

  function priceHTML(p, kitContext) {
    var pr = prices(p);
    if (isKit(p, kitContext)) {
      var ref = (pr.compare && pr.compare > pr.price) ? pr.compare : pr.price;
      return '<span class="sb-now sb-now--kit">' + formatMoney(kitPrice(pr.price)) + '</span>' +
        '<span class="sb-was">' + formatMoney(ref) + '</span>';
    }
    var html = '<span class="sb-now">' + formatMoney(pr.price) + '</span>';
    if (pr.compare && pr.compare > pr.price) html += '<span class="sb-was">' + formatMoney(pr.compare) + '</span>';
    return html;
  }

  function kitLabel(p) {
    var pr = prices(p);
    if (pr.compare && pr.compare > pr.price) {
      return '-' + Math.round((1 - pr.price / pr.compare) * 100) + '% + ' + KIT_PCT + '% adicional';
    }
    return '-' + KIT_PCT + '% en kit';
  }

  function badgeHTML(p, kitContext) {
    if (isKit(p, kitContext)) return '<span class="sb-card__badge sb-card__badge--kit">' + kitLabel(p) + '</span>';
    var pr = prices(p);
    if (pr.compare && pr.compare > pr.price) return '<span class="sb-card__badge">-' + Math.round((1 - pr.price / pr.compare) * 100) + '%</span>';
    return '';
  }

  function buttonHTML(p, label) {
    if (p.variants.length > 1) {
      return '<a class="sb-btn sb-btn--ghost" href="' + esc(p.url) + '">Ver opciones</a>';
    }
    var v = firstAvailableVariant(p);
    return '<button type="button" class="sb-btn" data-sb-add="' + v.id + '">' +
      '<svg aria-hidden="true" viewBox="0 0 20 20" width="14" height="14"><path d="M10 4v12M4 10h12" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" fill="none"/></svg>' +
      '<span>' + label + '</span></button>';
  }

  /* ---------- agregar al carrito ---------- */
  function addToCart(variantId, btn) {
    var cartDrawer = document.querySelector('cart-drawer');
    var body = { id: Number(variantId), quantity: 1 };
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      body.sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        if (state.status) {
          showError(btn, state.description || state.message || 'No se pudo agregar');
          return;
        }
        btn.classList.add('is-added');
        var span = btn.querySelector('span');
        if (span) span.textContent = 'Agregado';
        if (window.publish && window.PUB_SUB_EVENTS) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'sauber-complementos', productVariantId: variantId, cartData: state }); } catch (e) {}
        }
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(state);
        } else {
          window.location.href = ROOT + 'cart';
        }
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        showError(btn, 'No se pudo agregar');
      });
  }

  function showError(btn, msg) {
    var span = btn.querySelector('span');
    var old = span ? span.textContent : '';
    btn.classList.add('is-error');
    if (span) span.textContent = 'Sin stock';
    btn.title = msg;
    setTimeout(function () {
      btn.classList.remove('is-error');
      if (span) span.textContent = old;
    }, 2500);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sb-add]');
    if (btn) {
      e.preventDefault();
      if (!btn.classList.contains('is-loading')) addToCart(btn.getAttribute('data-sb-add'), btn);
      return;
    }
    var nav = e.target.closest('[data-sb-nav]');
    if (nav) {
      e.preventDefault();
      var box = nav.closest('.sb-comp, .sb-cu');
      var track = box.querySelector('.sb-comp__track, .sb-cu__track');
      var card = track.querySelector('.sb-card, .sb-mini');
      var step = card ? card.getBoundingClientRect().width + 10 : track.clientWidth * 0.8;
      track.scrollBy({ left: nav.getAttribute('data-sb-nav') === 'next' ? step : -step, behavior: 'smooth' });
    }
  });

  /* ---------- navegación de carruseles ---------- */
  var NAV_HTML =
    '<div class="sb-nav">' +
      '<button type="button" data-sb-nav="prev" aria-label="Anterior"><svg viewBox="0 0 20 20" width="16" height="16"><path d="M12.5 4.5 7 10l5.5 5.5" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<button type="button" data-sb-nav="next" aria-label="Siguiente"><svg viewBox="0 0 20 20" width="16" height="16"><path d="M7.5 4.5 13 10l-5.5 5.5" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
    '</div>';

  function bindNav(box) {
    var track = box.querySelector('.sb-comp__track, .sb-cu__track');
    if (!track) return;
    track.addEventListener('scroll', function () { updateNav(box); }, { passive: true });
    updateNav(box);
    setTimeout(function () { updateNav(box); }, 400);
  }

  window.addEventListener('resize', function () {
    document.querySelectorAll('.sb-comp.is-ready, .sb-cu.is-ready').forEach(updateNav);
  });

  function updateNav(box) {
    var track = box.querySelector('.sb-comp__track, .sb-cu__track');
    var prev = box.querySelector('[data-sb-nav="prev"]');
    var next = box.querySelector('[data-sb-nav="next"]');
    if (!track || !prev) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    box.classList.toggle('sb-scrollable', max > 0);
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max;
  }

  /* ---------- página de producto ---------- */
  function cardHTML(p, kitContext) {
    return '<div class="sb-card' + (isKit(p, kitContext) ? ' sb-card--kit' : '') + '">' +
      '<a class="sb-card__media" href="' + esc(p.url) + '" tabindex="-1">' +
        (p.featured_image ? '<img src="' + esc(img(p.featured_image, 400)) + '" alt="' + esc(p.title) + '" loading="lazy" width="400" height="400">' : '') +
        badgeHTML(p, kitContext) +
      '</a>' +
      '<div class="sb-card__body">' +
        '<a class="sb-card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<div class="sb-price">' + priceHTML(p, kitContext) + '</div>' +
        buttonHTML(p, 'Agregar') +
      '</div>' +
    '</div>';
  }

  function renderProductBlock(box) {
    if (box.getAttribute('data-sb-ready')) return;
    box.setAttribute('data-sb-ready', '1');
    var pid = box.getAttribute('data-product-id');
    var limit = Number(box.getAttribute('data-limit')) || 10;
    var kitContext = KIT_ON && (box.getAttribute('data-machine') === 'true' || MACHINES[String(pid)]);
    fetchRecs(pid, limit).then(function (products) {
      if (!products.length) { box.remove(); return; }
      var anyKit = kitContext && products.some(function (p) { return KIT[String(p.id)]; });
      var heading = anyKit ? 'Completa tu kit con ' + KIT_PCT + '% OFF' : (box.getAttribute('data-heading') || 'Complementa tu compra');
      var sub = anyKit ? KIT_PCT + '% de descuento en un complemento por cada máquina o carro' : box.getAttribute('data-subheading');
      box.innerHTML =
        '<div class="sb-comp__head">' +
          '<div><h2 class="sb-comp__title">' + esc(heading) + '</h2>' +
          (sub ? '<p class="sb-comp__sub">' + esc(sub) + '</p>' : '') + '</div>' +
          NAV_HTML +
        '</div>' +
        '<div class="sb-comp__track">' + products.map(function (p) { return cardHTML(p, kitContext); }).join('') + '</div>';
      box.classList.add('is-ready');
      box.classList.toggle('sb-comp--kit', !!anyKit);
      bindNav(box);
    });
  }

  function initProductBlocks() {
    document.querySelectorAll('.sb-comp[data-product-id]').forEach(renderProductBlock);
  }

  /* ---------- carrito lateral ---------- */
  var cartBusy = false;

  function miniHTML(p, kitContext) {
    var kit = isKit(p, kitContext);
    return '<div class="sb-mini' + (kit ? ' sb-mini--kit' : '') + '">' +
      '<a href="' + esc(p.url) + '" class="sb-mini__media">' +
        (p.featured_image ? '<img src="' + esc(img(p.featured_image, 160)) + '" alt="' + esc(p.title) + '" loading="lazy" width="64" height="64">' : '') +
      '</a>' +
      '<div class="sb-mini__info">' +
        (kit ? '<span class="sb-mini__tag">' + kitLabel(p) + '</span>' : '') +
        '<a class="sb-mini__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<div class="sb-price sb-price--sm">' + priceHTML(p, kitContext) + '</div>' +
      '</div>' +
      buttonHTML(p, 'Agregar') +
    '</div>';
  }

  function shipHTML(total) {
    if (!FREE_SHIP) return '';
    var missing = FREE_SHIP - total;
    var pct = Math.max(4, Math.min(100, Math.round(total / FREE_SHIP * 100)));
    var msg = missing > 0
      ? 'Te faltan <strong>' + formatMoney(missing) + '</strong> para <strong>despacho gratis</strong> en Santiago'
      : '<strong>¡Tienes despacho gratis</strong> en Santiago!';
    return '<p class="sb-ship__msg">' +
      '<svg aria-hidden="true" viewBox="0 0 24 24" width="18" height="18"><path d="M3 6h11v9H3zM14 9h4l3 3v3h-7z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><circle cx="7" cy="17.5" r="1.8" fill="currentColor"/><circle cx="17" cy="17.5" r="1.8" fill="currentColor"/></svg>' +
      '<span>' + msg + '</span></p>' +
      '<div class="sb-ship__bar"><span style="width:' + pct + '%"></span></div>';
  }

  function renderCart() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || cartBusy) return;
    var inner = drawer.querySelector('.drawer__inner');
    var footer = drawer.querySelector('.drawer__footer');
    var items = drawer.querySelector('cart-drawer-items');
    if (!inner || !footer || drawer.classList.contains('is-empty')) return;
    if (inner.querySelector('.sb-cu') || inner.querySelector('.sb-ship')) return;

    cartBusy = true;
    var holder = document.createElement('div');
    holder.className = 'sb-cu';
    holder.setAttribute('aria-live', 'polite');
    footer.parentNode.insertBefore(holder, footer);

    var ship = null;
    if (FREE_SHIP && items) {
      ship = document.createElement('div');
      ship.className = 'sb-ship';
      items.parentNode.insertBefore(ship, items);
    }

    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (ship && ship.isConnected) {
          ship.innerHTML = shipHTML(cart.total_price || 0);
          ship.classList.add('is-ready');
          ship.classList.toggle('is-done', (cart.total_price || 0) >= FREE_SHIP);
        }
        var inCart = {};
        var bases = [];
        var hasMachine = false;
        (cart.items || []).forEach(function (it) {
          inCart[it.product_id] = true;
          if (MACHINES[String(it.product_id)]) hasMachine = true;
          if (bases.indexOf(it.product_id) === -1) bases.push(it.product_id);
        });
        bases = bases.slice(0, 3); // los últimos agregados aparecen primero
        if (!bases.length) return { products: [], kit: false };
        return Promise.all(bases.map(function (id) { return fetchRecs(id, 10); })).then(function (lists) {
          var seen = {}, out = [];
          lists.forEach(function (list) {
            list.forEach(function (p) {
              if (!inCart[p.id] && !seen[p.id]) { seen[p.id] = true; out.push(p); }
            });
          });
          var kitContext = KIT_ON && hasMachine;
          if (kitContext) {
            // los que tienen descuento primero
            out.sort(function (a, b) { return (KIT[String(b.id)] ? 1 : 0) - (KIT[String(a.id)] ? 1 : 0); });
          }
          return { products: out.slice(0, Number(CFG.cartLimit) || 6), kit: kitContext };
        });
      })
      .then(function (res) {
        if (!holder.isConnected) return;
        var products = res.products;
        if (!products.length) { holder.innerHTML = ''; return; } // queda vacío y oculto: marca que ya se procesó
        var anyKit = res.kit && products.some(function (p) { return KIT[String(p.id)]; });
        var heading = anyKit ? 'Completa tu kit con ' + KIT_PCT + '% OFF' : (CFG.cartHeading || 'Completa tu compra');
        holder.innerHTML =
          '<div class="sb-cu__head"><p class="sb-cu__title"><svg aria-hidden="true" viewBox="0 0 20 20" width="16" height="16"><path d="M10 2.5l2.2 4.6 5 .7-3.6 3.5.9 5-4.5-2.4-4.5 2.4.9-5L2.8 7.8l5-.7z" fill="currentColor"/></svg>' +
          esc(heading) + '</p>' + NAV_HTML + '</div>' +
          '<div class="sb-cu__track">' + products.map(function (p) { return miniHTML(p, res.kit); }).join('') + '</div>';
        holder.classList.add('is-ready');
        bindNav(holder);
      })
      .catch(function () { if (holder.isConnected) holder.innerHTML = ''; })
      .then(function () { cartBusy = false; });
  }

  function watchCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var t;
    var obs = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(renderCart, 120);
    });
    obs.observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    renderCart();
  }

  function init() {
    initProductBlocks();
    watchCartDrawer();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // por si el editor del tema recarga secciones
  document.addEventListener('shopify:section:load', initProductBlocks);
})();
